import React, { useEffect } from 'react';

import { Outlet } from 'react-router-dom';
import { Status, BaseState } from '@prometheus/types';
import { SpinnerWidgetContainer } from '@prometheus/features';

import { useSelector } from 'react-redux';
import { LoginPage } from '../LoginPage';
import { LayoutSpinner } from '../AppLayout/AppLayout.styles';

export const PrivateRoute = (props: any) => {
  const { ...passProps } = props;

  const status = useSelector<BaseState, Status>(
    (state: any) => state.user.status
  );
  const loginStatus = useSelector<BaseState, Status>(
    (state: any) => state.user.loginStatus
  );

  if (status === Status.IN_PROGRESS || status === Status.INITIAL) {
    return (
      <SpinnerWidgetContainer>
        <LayoutSpinner size={70} />
      </SpinnerWidgetContainer>
    );
  }
  // if (true) {
  if (status === Status.SUCCESS) {
    return <Outlet {...passProps} />;
  }

  return <LoginPage hasError={loginStatus === Status.ERROR} />;
};
